(function() {

var _ = ui._;
ui.faderHide = faderHide;
ui.faderShow = faderShow;
ui.messageClose = messageClose;
ui.messageShow = messageShow;
ui.tooltipClose = tooltipClose;
ui.tooltipShow = tooltipShow;

var $fader;
var $messagesBox;

function messageClose(event) {
  if(event && event.preventDefault)
    event.preventDefault();
  _(event.target).parent().remove();
}

function messageShow(message, type, autoclose) {
  if(!$messagesBox)
    $messagesBox = _('div').appendTo(_(d.body)).attr('class', 'messages-box');
  var $close;
  _('div').appendTo($messagesBox).attr('class', 'message-box message-box-' + type).text(message).append(
    $close = _('i').attr('class', 'fa fa-times', 'onclick', 'ui.messageClose(event)')
  );
  if(autoclose || (autoclose === undefined))
    setTimeout(messageClose, 5000, {'target': $close.el});
}

function faderToggle(force) {
  if(!$fader)
    $fader = _('div').appendTo(_(d.body)).attr('class', 'fader').append(
      _('svg').attr('class', 'svg-icon-loader').append(_('use').attr('href', '#svg-icon-loader'))
    );
  $fader.toggleClass('fader-active', force);
}

function faderHide() {
  faderToggle(false);
}

function faderShow() {
  faderToggle(true);
}

function tooltipClose(event) {
  if(event) {
    event.preventDefault();
    event.stopPropagation();
  }
  var $he = _('#tooltip-box');
  var onclose = $he.attrGet('onclose');
  if(onclose)
    ui[onclose]($he);
  $he.remove();
}

function tooltipShow(event, text, class_ex, onclose) {
  event.preventDefault && event.preventDefault();
  event.stopPropagation && event.stopPropagation();
  tooltipClose();
  var $he;
  _(event.target).parent().append(
    $he = _('div').attr('class', 'tooltip-box' + (class_ex ? ' ' + class_ex : ''), 'id', 'tooltip-box').append(
      _('div').attr('class', 'tooltip-box-window').html(text),
      _('i').attr('class', 'fa fa-times', 'onclick', 'ui.tooltipClose(event)')
    )
  );
  if(onclose)
    $he.attr('onclose', onclose);
  return $he;
}

})();